import qcDefCityIdsStore from "../store/qcDefCityIds";


const useQcDefCityIds = (playerId) => {
    const defCityIds = qcDefCityIdsStore((state) => state.cityIds);
    const setDefCityId = qcDefCityIdsStore((state) => state.setCityId);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        playerDefCityIds: playerId == null ? [] : defCityIds[playerId] ?? [],
        defCityIds,
        setDefCityId
    };
};

export default useQcDefCityIds;
